import React from 'react';
import PropTypes from 'prop-types';
import { testAttributes } from './Constants';
import * as styles from './WpPage.module.scss';
import Breadcrumb from '../../Atoms/Breadcrumb';

const WpPage = ({
    title = null,
    editorial,
    articles = null,
    breadcrumbs = []
}) => 
{
    function injectIntoElement(node) 
    {
        if (!React.isValidElement(node)) return node;
        if (node.key === '1') 
        {
            return React.cloneElement(node, {
                ...node.props,
                style: { ...node.props.style},
                children: [
                    <Breadcrumb
                        breadcrumbs={breadcrumbs}
                        hasHero={false}
                    />,

                    ...React.Children.toArray(node.props.children),
                ],
            });
        }
        return node;
    }
    const modified = editorial.map((el) => injectIntoElement(el));

    return <div data-testid={testAttributes.WP_PAGE_ROOT} className={`${styles.wpPageRoot} QLD_ROOT`}>
        <div data-testid={testAttributes.WP_PAGE_LAYOUT} className={styles.wpPageLayout}>
            {title}
            {modified}
        </div>
        <div data-testid={testAttributes.WP_PAGE_RELATED_GRID} className={styles.wpPageRelatedGrid}>
            {articles}
        </div>
    </div>
};
WpPage.propTypes = {
    /** Breadcrumbs to be displayed on the page */
    breadcrumbs: PropTypes.array,
    /** H1 title of page, or null if H1 is embedded within another section */
    title: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.node,
        PropTypes.string
    ]),
    /** Content of page */
    editorial: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.any),
        PropTypes.string,
        PropTypes.element
    ]).isRequired,
    /** posts grid component including title and more */
    articles: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.any),
        PropTypes.object
    ])
}

export default WpPage;